import { BadgeArtSpec } from './types.js'

/**
 * Short content hash of a badge's art (FNV-1a over the JSON spec, base36). Used as the
 * PNG cache key, ETag and `?v=` so any change in shape/palette/tier/icon busts caches —
 * `badges.updated_at_utc` does not move on category edits and is not auto-bumped.
 */
export const badgeArtVersion = (spec: BadgeArtSpec): string => {
    const json = JSON.stringify([
        spec.shape,
        spec.palette,
        spec.tier,
        spec.iconMarkup,
        spec.anniversaryYears,
    ])
    let h = 0x811c9dc5
    for (let i = 0; i < json.length; i++) {
        h ^= json.charCodeAt(i)
        h = Math.imul(h, 0x01000193) >>> 0
    }
    return h.toString(36)
}
